import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import OliverText from "@builder/components/general/OliverText";
import SelectInput from "@builder/components/general/SelectInput";
import { getlinkedInputDisplaysAsTargets, getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { CustomNumpadNode } from "@common/build/types";

const ChooselinkedInputDisplayTarget = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as CustomNumpadNode;

    const targetOptions = useAppSelector(getlinkedInputDisplaysAsTargets);
    const currentTarget = node?.target;
    const chooseTargetCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["target"], value }));
    };

    return (
        <SidebarCollapse title="Target" parent={parent}>
            <OliverText
                text="Set target"
                size="xs"
                style={{ marginBottom: "-8px" }}
                translatePrefix="editable.customNumpadTarget."
            />
            <OliverText
                text="This will update the linked input display whenever numpad is in use."
                size="xxs"
                translatePrefix="editable.customNumpadTarget."
            />
            <SelectInput layout="column" value={currentTarget} options={targetOptions} callback={chooseTargetCallback} noTranslate />
        </SidebarCollapse>
    );
};

export default ChooselinkedInputDisplayTarget;
